/**
 * Labels for ``POST …/execute`` response field ``codeConnectorResolution.source``.
 * Mirrors ``execute_network._resolve_code_connector_secret_id`` semantics.
 */

export const CODE_CONNECTOR_SOURCE_LABEL = {
  explicit: 'Explicit (this run)',
  pool_override: 'Pool pin',
  network_default: 'Network default',
  none: 'No connector secret',
};

/**
 * Short line for consoles / Composer system events.
 *
 * @param {{ source?: string, secretId?: string|null }} cc
 */
export function formatCodeConnectorResolutionLine(cc) {
  if (!cc || typeof cc !== 'object') return '';
  const src = CODE_CONNECTOR_SOURCE_LABEL[cc.source] || cc.source || '';
  if (!src) return '';
  const sid = String(cc.secretId || '').trim();
  const tail =
    cc.source !== 'none' && sid.length > 0
      ? ` · …${sid.slice(-10)}`
      : '';
  return `Git connector: ${src}${tail}.`;
}
